import { render, staticRenderFns } from "./CbuAlias.vue?vue&type=template&id=2ec5dc8d"
import script from "./CbuAlias.vue?vue&type=script&lang=js"
export * from "./CbuAlias.vue?vue&type=script&lang=js"
import style0 from "./CbuAlias.vue?vue&type=style&index=0&id=2ec5dc8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports